import React from "react";
import { motion } from "framer-motion";

export default function SubHead() {
  return (
    <motion.div className="text-light md:mt-10 mt-8 *:relative *:min-h-[28vh] grid lg:grid-cols-3 sm:grid-cols-2 gap-5 *:z-0 *:overflow-hidden *:rounded-2xl *:flex *:flex-col *:justify-center *:p-8 *:gap-3 *:bg-dark">
      <motion.div>
        <p className="sub-heading font-bold text-bright">50+</p>
        <p className="med-text pl-1 font-semibold opacity-90">Completed Projects</p>
        <img
          src="/assets/images/sub-head-2.jpg"
          alt=""
          className=" object-contain w-full -z-10 absolute right-0 mix-blend-difference"
        />
      </motion.div>
      <motion.div>
        <p className="sub-heading font-bold text-bright">25</p>
        <p className="med-text pl-1 font-semibold opacity-90">Years of Experience</p>
        <img
          src="https://picsum.photos/id/320/3000"
          alt=""
          className=" object-contain w-full -z-10 absolute right-0 mix-blend-color-dodge "
        />
      </motion.div>
      <motion.div>
        <p className="sub-heading font-bold text-bright">20+</p>
        <p className="med-text pl-1 font-semibold opacity-90">Experienced Experts</p>
        <img
          src="/assets/images/sub-head-3.jpg"
          alt=""
          className=" object-contain w-full -z-10 absolute right-0 mix-blend-color-dodge "
        />
      </motion.div>
    </motion.div>
  );
}
